<template>
  <VOverlay
    v-model="overlay"
    :close-on-back="false"
    persistent
    class="align-center justify-center"
  >
    <div>
      <VImg
        :src="$vuetify.theme.current.dark ? loaderDarkTheme : loader"
        height="250px"
        width="250px"
      />
    </div>
  </VOverlay>
</template>

<script setup>
import loader from '@images/logos/loader.svg'
import loaderDarkTheme from '@images/logos/loaderBlank.svg'

const props = defineProps({
  modelValue: {
    type: [String, Array, Object, Boolean],
    required: true,
  },
})

const emit = defineEmits(['update:modelValue'])

const overlay = computed({ 
  get: () => props.modelValue, 
  set: value => emit('update:modelValue', value),
}) 
</script>
